import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { usePosAuth } from '@/contexts/PosAuthContext';
import { formatApiError } from '@/lib/api';
import { Delete } from 'lucide-react';

const KEYS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '', '0', 'back'];

export default function PosLogin() {
  const { loginWithPin } = usePosAuth();
  const navigate = useNavigate();
  const [pin, setPin] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const press = async (key) => {
    if (busy) return;
    if (key === 'back') return setPin((p) => p.slice(0, -1));
    if (key === '' || pin.length >= 4) return;
    const next = pin + key;
    setPin(next);
    setError('');
    if (next.length === 4) {
      setBusy(true);
      try {
        await loginWithPin(next);
        navigate('/pos/home');
      } catch (err) {
        setError(formatApiError(err));
        setPin('');
      } finally {
        setBusy(false);
      }
    }
  };

  return (
    <div className="min-h-screen bg-obsidian flex items-center justify-center px-6">
      <div className="w-full max-w-xs text-center">
        <img
          src="/logo-emblem.png"
          alt="The Tiffin by The Virsa"
          className="mx-auto w-24 h-24 rounded-full object-cover shadow-2xl ring-1 ring-white/10"
        />
        <p className="text-white/50 text-sm mt-4 mb-8">Store POS — Enter Your PIN</p>

        <div className="flex items-center justify-center gap-3 mb-8" data-testid="pos-pin-dots">
          {[0, 1, 2, 3].map((i) => (
            <div
              key={i}
              className={`h-4 w-4 rounded-full border-2 border-saffron transition-colors duration-150 ${
                i < pin.length ? 'bg-saffron' : 'bg-transparent'
              }`}
            />
          ))}
        </div>

        {error && <p className="text-sm text-red-400 mb-4" data-testid="pos-pin-error">{error}</p>}
        {busy && <p className="text-sm text-white/60 mb-4">Checking…</p>}

        <div className="grid grid-cols-3 gap-3">
          {KEYS.map((key, i) =>
            key === '' ? (
              <div key={i} />
            ) : (
              <button
                key={i}
                data-testid={key === 'back' ? 'pos-pin-backspace' : `pos-pin-key-${key}`}
                onClick={() => press(key)}
                className="h-16 rounded-2xl bg-white/10 hover:bg-white/20 text-white text-2xl font-heading font-semibold flex items-center justify-center transition-colors duration-150"
              >
                {key === 'back' ? <Delete size={22} /> : key}
              </button>
            ),
          )}
        </div>
      </div>
    </div>
  );
}
